import { useEffect, useState } from 'react';
import { get } from 'lodash';

import { useTabVisibility } from './useTabVisibility';
import OrderActions from '../actions/OrderActions';
import CookieHelper from '../helpers/Cookie';
import { ActionTypes, CookieKeys } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

export const useTabAwareOrderUpdater = () => {
    const { isTabActive } = useTabVisibility();
    const [prevJourneysAmount, setPrevJourneysAmount] = useState(null);

    useEffect(() => {
        const { order } = CookieHelper.get(CookieKeys.ORDER, true) || {};
        const journeysAmount = get(order, 'journeysAmount', 0);
        const id = get(order, 'id', null);
        if (prevJourneysAmount === null) {
            setPrevJourneysAmount(journeysAmount);
        } else if (journeysAmount !== prevJourneysAmount) {
            setPrevJourneysAmount(journeysAmount);
            if (id) {
                OrderActions.refresh(order);
            } else {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.BASKET_CLEARED
                });
            }
        }

    }, [isTabActive, prevJourneysAmount]);
};




// WEBPACK FOOTER //
// ./src/hooks/useTabAwareOrderUpdater.js